import io from 'socket.io-client';

// Single place that creates Socket.IO connections for the app.
//
// We prefer a real WebSocket and only fall back to HTTP long-polling when a
// proxy blocks the upgrade. Listing `websocket` first makes the client attempt
// it immediately instead of starting on polling and upgrading later; combined
// with `tryAllTransports` (socket.io-client >= 4.8) the client transparently
// retries with `polling` if the WebSocket handshake fails, so live updates keep
// working behind proxies that don't support WebSockets.
//
// Long-polling is expensive: every server message ends the pending poll and
// forces a new request, so staying on WebSocket is what keeps request volume
// low. See api-echo job_notify.go for the matching server-side throttling.
export default function createSocket(options = {}) {
  return io({
    transports: ['websocket', 'polling'],
    tryAllTransports: true,
    ...options,
  });
}
